import Plyr from 'plyr';
import 'plyr/dist/plyr.css';

document.querySelectorAll('.js-plyr').forEach(el => new Plyr(el));
